import t from "../../rc-util/es/warning.mjs";
import * as i from "react";
var l = "RC_FORM_INTERNAL_HOOKS", e = function() {
  t(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, a = /* @__PURE__ */ i.createContext({
  getFieldValue: e,
  getFieldsValue: e,
  getFieldError: e,
  getFieldWarning: e,
  getFieldsError: e,
  isFieldsTouched: e,
  isFieldTouched: e,
  isFieldValidating: e,
  isFieldsValidating: e,
  resetFields: e,
  setFields: e,
  setFieldValue: e,
  setFieldsValue: e,
  validateFields: e,
  submit: e,
  getInternalHooks: function() {
    return e(), {
      dispatch: e,
      initEntityValue: e,
      registerField: e,
      useSubscribe: e,
      setInitialValues: e,
      destroyForm: e,
      setCallbacks: e,
      registerWatch: e,
      getFields: e,
      setValidateMessages: e,
      setPreserve: e,
      getInitialValue: e
    };
  }
});
export {
  l as HOOK_MARK,
  a as default
};
//# sourceMappingURL=FieldContext.mjs.map
